import React from 'react';
import proptypes from 'prop-types';
const { string: stringType, number } = proptypes;
import { Pill } from '@one-thd/sui-atomic-components';
import { useImpression } from '@thd-olt-component-react/impression';
import { track } from '../subcomponents/related-search-analytics';

export const PopularCategory = ({
  copyText,
  url,
  componentId,
  index
}) => {
  const handlePopularCategoryClick = (copyText) => {
    if (window?.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('popular-category.UPDATE', { updatedSearchTerm: '' });
    }
    track(copyText);
  };

  const { ref, clickID } = useImpression({
    data: {
      id: componentId,
      name: 'PopularCategory',
      component: 'PopularCategory',
      position: index + 1,
      type: 'content',
      category: copyText?.replace(/\W+/g, '')
    },
  });

  return (
    <div
      className="sui-bg-primary sui-rounded-full"
      ref={ref}
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
    >
      <Pill
        label={copyText}
        component="a"
        href={url}
        onClick={() => handlePopularCategoryClick(copyText)}
        clickable
      />
    </div>
  );
};

PopularCategory.propTypes = {
  copyText: stringType.isRequired,
  url: stringType.isRequired,
  componentId: stringType.isRequired,
  index: number.isRequired
};